import React, { useState, useEffect, useRef } from 'react';
import { useSpring, animated } from "react-spring";
import { useMeasure } from "react-use";
import style from "../Components/contentview.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ReactPlayer from 'react-player'

import lysvark from "../assets/ikon_app_lysvaerk.png";
import popup from "../assets/ikon_app_popup.png";
// import RouteSection from '.Components/RouteSection'
import { Switch } from '@material-ui/core';
import AudioPlayer from '../Components/AudioPlayer';
import RouteSection from '../Components/RouteSection';
// import AudioPlayer from '.../AudioPlayer';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width: (width > 450) ? 450 : width,
      height
    };
  }

function ReffenContentView(props) {
    const defaultHeight = "100px";
    const [open, toggle] = useState(false);
    const [isDanish, toggleLanguage] = useState(true);
    const [showFilter, setShowFilter] = useState(true);
    const [contentHeight, setContentHeight] = useState(defaultHeight);
    const [ref, { width }] = useMeasure();

    // Animations
    const expand = useSpring({
        config: { friction: 10 },
        height: open ? `${contentHeight}px` : defaultHeight
    });
    const spin = useSpring({
        config: { friction: 10 },
        transform: open ? "rotate(180deg)" : "rotate(0deg)"
    });

    useEffect(()=>{
        if (!props.chosenLocation) {
            toggle(false)
        } else {
            toggle(true)
        }
    },[props.chosenLocation])

    useEffect(() => {
        //Sets initial height
        setContentHeight(width);
        
        //Adds resize event listener
        window.addEventListener("resize", setContentHeight(width));
        
        // Clean-up
        return window.removeEventListener("resize", setContentHeight(width));
    }, [width]);

    const setOverviewView = ()=> {

        // location:
        //     category: "DAC"
        //     content_dk: "dakdak"
        //     content_eng: ""
        //     id: "ab23deb-0ea-4246-1cb1-43e1665308a8"
        //     images: Array(1)
                // 0:
                    // name: "image0.jpg"
                    // url: "https://firebasestorage.googleapis.com/v0/b/within1hour-1483711039788.appspot.com/o/cphlight-images%2Fab23deb-0ea-4246-1cb1-43e1665308a8%2Fimage0.jpg?alt=media&token=0179bd18-7fd8-47a5-9fca-78bbfe0eab24"
        //     latitude: "55.692843"
        //     link: ""
        //     longitude: "12.579771"
        //     title_dk: "DACDAC-dak"
        //     title_eng: ""

        console.log('AllLocations: ', props.allLocations)

        const lightworks = props.allLocations.filter(item => item.category == 'Lightworks') 
        const dac = props.allLocations.filter(item => item.category == 'DAC') 
        const events = props.allLocations.filter(item => item.category == 'Events') 

        return(
            <div style={{textAlign: "left", paddingBottom: 40}}>
                
                {/* <h4>Kategorier</h4> */}
                {/* <img src={logo} alt="LOGO" width="80"/> */}
                <div style={{marginTop:10}}>
                <strong>Refshaleøen</strong>
                <br/>
                {/* List of the routes, lightworks and popups at Copenhagen Light Festival 2024, February 2-25 */}
                {/* <br/><br/> */}
                <i>Have a nice trip</i>
                </div>

{/* <button style={{marginTop:10}} onClick={() => setShowFilter(!showFilter)}>
<strong >
{showFilter ? "Hide": "Show"} Route filters
            </strong>
</button>

{showFilter &&
                <RouteSection routeUpdate={(change)=>{
                    props.routeUpdate(change)
                }} />
} */}

                
                <div style={styling.categoryHeader}>
                <div 
                style={{marginRight:10}}
                // style={{...styling.innerCircle, backgroundColor: "blue"}}
                >
                    {/* <RoomIcon style={styling.icon} /> */}
                    <img src={lysvark} alt="Lysværk" height="30" width="30"/>

                </div>
                
                <strong>Places</strong>
                </div>

                {props.allLocations.map((location, key) => {
                    return(
                        <div onClick={()=>{
                            props.locationClick({location})
                        }} style={
                            styling.listWorks
                          }>
                            <p key={key + '-' + location.title_dk}>{location.title_dk}</p> 
                            <ArrowRightIcon style={{color: "purple"}}/>
                        </div>
                    )
                })}
                
                {events.length > 0 && 
                    <div>
                        
                    <div style={styling.categoryHeader}>
                    <div 
                    style={{marginRight:10}}
                    >
                        {/* <StarIcon style={styling.icon} /> */}
                        <img src={popup} alt="Popup" height="30" width="30" />

                    </div>
                    <h5>Popups</h5>
                    </div>

                    {events.map((location, key) => {
                        return(
                            <div onClick={()=>{
                                props.locationClick({location})
                            }} style={
                                styling.listWorks
                            }>
                                <p key={key + '-' + location.title_dk}>{location.title_dk}</p> 
                                <ArrowRightIcon style={{color: "green"}}/>
                            </div>
                        )
                    })}
                    </div>
                }
            </div>
        )
    }

    const setContentView = (loca)=> {
        console.log("setContentView:" + JSON.stringify(loca))

        // const links = JSON.parse(loca.location.link)

        // console.log("setContentViewLINKS:" + links)
        // location:
        //     category: "DAC"
        //     content_dk: "dakdak"
        //     content_eng: ""
        //     id: "ab23deb-0ea-4246-1cb1-43e1665308a8"
        //     images: Array(1)
                // 0:
                    // name: "image0.jpg"
                    // url: "https://firebasestorage.googleapis.com/v0/b/within1hour-1483711039788.appspot.com/o/cphlight-images%2Fab23deb-0ea-4246-1cb1-43e1665308a8%2Fimage0.jpg?alt=media&token=0179bd18-7fd8-47a5-9fca-78bbfe0eab24"
        //     latitude: "55.692843"
        //     link: ""
        //     longitude: "12.579771"
        //     title_dk: "DACDAC-dak"
        //     title_eng: ""

        return(
            <div class="frame" 
            style={{
                textAlign: "left", 
                paddingBottom: 40, 
                width: getWindowDimensions().width - 30, 
                paddingTop: 10, 
                marginRight: 20,
                overflow: "scroll"}}>
                {/* <ArrowBackIcon /> */}
                <div onClick={()=>props.locationClick(null)} style={{...styling.innerCircle, backgroundColor: "black"}}>
                    <ArrowBackIcon style={styling.icon} />
                </div>
                {loca.location.title_dk && 
                    <div style={{borderBottom: '1px solid gray',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'}}>
                        <h3>{isDanish ? loca.location.title_dk : loca.location.title_eng}</h3>

                        <div>
                            {isDanish ? "DK" : "Eng"}
                            <Switch 
                            style={{color:"white"}}
                            color="primary"
                            name="checkedB"
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            checked={isDanish}
                            onChange={()=>{
                                toggleLanguage(!isDanish)
                            }}/>
                        </div>
                    </div>
                }
                
                {loca.location.content_dk && <p style={{whiteSpace: "pre-wrap"}}>{isDanish ? loca.location.content_dk : loca.location.content_eng}</p>}
                
                {loca.location.audio && audioView(loca.location.audio)}

                {imageRoll(loca.location.images)}

                {linkSection(loca.location.link)}

                {loca.location.video && videoView(loca.location.video)}

                {routeDirection(loca.location)}

                <br/>

                {/* {JSON.stringify(loca)} */}
            </div>
        )
    }

      const videoView = (video) => {
        // let url = 'https://firebasestorage.googleapis.com/v0/b/within1hour-1483711039788.appspot.com/o/audio%2FThunder-Mike_Koenig-315681025.mp3?alt=media&token=ce89e8ce-4954-4125-b6d9-f407d39c6340'
        // 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
        if (video && video.length > 0) {
            return(
                <div>
                    <h3>Videoklip</h3>
                    {video.map((value, index)=>{
                    return(
                          <div>
                              <i style={{marginLeft: 20}}>{value.title}</i>
                              <ReactPlayer style={{marginTop: 20}} url={value.url} playing={false} controls={true} 
                              width={'400px'} 
                              />

                          </div>
                        )
                    })}
                </div>
            )
        }
      }

      const linkSection = links => {
        const linkObj = JSON.parse(links)

        const linkType  = link => {
            if (link.category== "link")  {
                return(
                <a href={link.value} target="_blank">{link.key}</a>
                )
            } else if (link.category ==  "text") {
                return <a href="#" 
                        onClick={() => {
                        alert(link.value)
                    }}>{link.key}</a>
            }
        }

        function linkSections(section) {
            return (
                <div>
                    <strong>{section.section}</strong>
                    {
                        section.links.map(link => {
                            return <div>
                                    {linkType(link)}
                                <br/>
                                </div>
                        })
                    }
                </div>
            )
        }

        if (linkObj) {
            return (
                <div id="myDiv">
                    <h3>Link</h3>
                    {
                        linkObj.map(section => {
                            return linkSections(section)
                        })
                    }
                </div>
            )
        }
      }

      const routeDirection = (loca) => {

        if (props.userLocation && loca.latitude && loca.longitude) {
          //https://developers.google.com/maps/documentation/javascript/directions
          var directulrl = 'https://www.google.dk/maps/dir/'+props.userLocation.latitude+','+props.userLocation.longitude+'/'+loca.latitude+','+loca.longitude
          const directurl = 'https://www.google.dk/maps/dir/55.7061217,12.4787483/55.7061217,12.5787483'
            return(
                <div>
                    <br/>
                    <h3>Rutevejledning</h3>
                    <a href={directulrl} target="_blank">Vis ruten med Google Maps</a>
                    <br/>
                </div>
            )
        }
      }

      const audioView = (audioarray) => {
        let url = 'https://firebasestorage.googleapis.com/v0/b/within1hour-1483711039788.appspot.com/o/audio%2FThunder-Mike_Koenig-315681025.mp3?alt=media&token=ce89e8ce-4954-4125-b6d9-f407d39c6340'
        // 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
        if (audioarray && audioarray.length > 0) {
            return(
                <div>
                    <h3>{isDanish ? "Lydklip" : "Audioclip"}</h3>
                    {audioarray.map((value, index)=>{
                        if (value.showInApp == true) {
                            return(
                                <div>
                                    {/* <i style={{marginLeft: 20}}>{value.title}</i>
                                    <br/> */}
                                    <AudioPlayer audio={value} />
                                    {/* <ReactAudioPlayer 
                                    style={{marginTop:5}}
                                    controlsList="nodownload"
                                    src={value.url}
                                    autoPlay={false}
                                    onPlay={()=>{
                                        console.log("PLAY PRESSED")
                                    }}
                                    controls
                                /> */}
                                </div>
                              )
                        }
                    })}
                </div>
            )
        }
      }

    const imageRoll = (images)=> {
        if (images && images.length > 0) {
            return(
                <div>
                    {
                        images.map((img, i) => {
                            return(
                                <div>
                                <img 
                                style={{width:"100%", marginTop: 20}}
                                    src={img.url}
                                    alt="new"
                                    key={"imageroll"+i}
                                />
                                <br/><br/>
                            </div>
                            )
                        })
                    }
                </div>
            )
        }
    }

    return(
        <div style={
            {
                position: "absolute",
        left: 0, 
        top: 0, 
        // paddingRight: 20,
        width: getWindowDimensions().width}
            // [
                // styling.menuWrapper
        // {width: getWindowDimensions().width}
        // ]
        }>
        <div 
        // className={style.wrapper}
        >
        <animated.div className={style.accordion} style={expand}>
            <div ref={ref} className={style.content} style={{overflow:"scroll"}}>
                

                {(props.chosenLocation && !props.chosenLocation.isUsersPosition) 
                ? setContentView(props.chosenLocation) : setOverviewView()}

                {/* {!props.chosenLocation && setOverviewView()} */}

            </div>
        </animated.div>
      <animated.button
        className={style.expand}
        onClick={() => toggle(!open)}
        style={spin}
      >
        <FontAwesomeIcon icon={faChevronDown} />
      </animated.button>
    </div>
        {/* // <div style={styling.menuWrapper}>
        //     {iconType(props.location.category)} */}
        </div>
    )
}

const styling = {
    menuWrapper : { 
        position: "absolute",
        left: 0, 
        top: 0, 
        // right: 60,
        // minWidth: 400,
        // width: 370,
        paddingRight: 20,

        // height: "50%", 
        // minWidth: 200, 
        // width: "50%"
        // backgroundColor: "white", 
        // borderRadius: 15, 
        // display: 'flex',
        // alignItems: 'center',
        // justifyContent: 'center',
    },
    icon : {
        color:"white", 
        height: 20, 
        width: 20
    },
    innerCircle : { 
        height: 28, 
        width: 28, 
        borderRadius: 14, 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 10
    },
    categoryHeader: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 20
    },
    listWorks: {
        borderBottom: '1px solid gray',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    underline: {
        textDecoration: 'underline'
      }

}

export default ReffenContentView